import {
  Card,
  CardContent,
  Grid,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

const CarListSkeleton = () => {
  return (
    <Grid item xs={12} md={3} sx={{ display: "flex" }} >
      <Card variant="outlined" sx={{ borderRadius: "1rem" }}>
        <CardContent>
          <Stack direction="column" useFlexGap spacing={1}>
            <Skeleton
              sx={{ bgcolor: "white.light" }}
              variant="rectangular"
              width="100%"
              height={200}
              animation="wave"
            />
            <Typography variant="h3">
              <Skeleton
                sx={{ bgcolor: "white.light" }}
                variant="text"
                animation="wave"
              />
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap>
              {[...Array(4).keys()].map((item, index) => (
                <Skeleton
                  sx={{ bgcolor: "white.light" }}
                  variant="rectangular"
                  animation="wave"
                  width={100}
                  height={75}
                  key={index}
                />
              ))}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default CarListSkeleton;
